/**
 * In-memory access token holder. The token is intentionally NOT persisted to
 * localStorage (XSS hardening); the refresh token lives in an httpOnly cookie
 * the browser sends automatically, and the interceptor refreshes on 401.
 */
let accessToken: string | null = null;

export const tokenStore = {
  get(): string | null {
    return accessToken;
  },
  set(token: string | null): void {
    accessToken = token;
  },
  clear(): void {
    accessToken = null;
  },
};
